import React, {ReactNode} from 'react';

import {Box, Typography} from '@mui/material';

import {COLORS} from '@/styles/colors';

import './styles';

interface GeoMapsProps {
  backgroundColor?: string;
  srcImage?: string;
  widthImage?: number;
  heightImage?: number;
  title?: string;
  description?: string;
  iconReview?: string;
  textReview?: string;
  footer?: ReactNode;
}

export const SmartBanner: React.FC<GeoMapsProps> = ({
  backgroundColor = COLORS.ON_SURFACE,
  srcImage,
  widthImage = 72,
  heightImage = 72,
  title,
  description,
  iconReview,
  textReview,
  footer,
}: GeoMapsProps) => {
  return (
    <Box
      className="smart-banner-container"
      bgcolor={backgroundColor}>
      <Box className="smart-banner-content">
        {srcImage && (
          <img
            src={srcImage}
            width={widthImage}
            height={heightImage}
          />
        )}
        <Box className="smart-banner-description-content">
          <Box className="smart-banner-description">
            <Typography className="smart-banner-title">{title}</Typography>
            <Typography className="smart-banner-description">
              {description}
            </Typography>
          </Box>
          <Box className="smart-banner-description">
            {iconReview && (
              <img
                src={iconReview}
                width={80}
              />
            )}
            <Typography className="smart-banner-description">
              {textReview}
            </Typography>
          </Box>
        </Box>
      </Box>
      {footer && <Box className="smart-banner-footer">{footer}</Box>}
    </Box>
  );
};
